// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck todo
import * as NaiveUI from 'naive-ui'
import { useAppStore } from '@/store'
import { isNil } from 'lodash-es'

export function setupMessage(NMessage: NaiveUI.MessageApi) {
  class Message {
    static instance: Message
    constructor() {
      // 单例模式
      if (Message.instance) return Message.instance
      Message.instance = this
      this.message = {}
      this.removeTimer = {}
    }

    removeMessage(key: string, duration = 3000) {
      this.removeTimer[key] && clearTimeout(this.removeTimer[key])
      this.removeTimer[key] = setTimeout(() => {
        this.message[key]?.destroy()
      }, duration)
    }

    destroy(key, duration = 200) {
      setTimeout(() => {
        this.message[key]?.destroy()
      }, duration)
    }

    showMessage(type, content, option = {}) {
      console.log(type, content, option)
      if (Array.isArray(content)) {
        return content.forEach((msg) => NMessage[type](msg, option))
      }

      if (!option.key) {
        option.key = content
        // return NMessage[type](content, option)
      }

      const currentMessage = this.message[option.key]
      if (currentMessage) {
        currentMessage.type = type
        currentMessage.content = content
      } else {
        this.message[option.key] = NMessage[type](content, {
          ...option,
          duration: 0,
          onAfterLeave: () => {
            typeof option.onAfterLeave === 'function' && option.onAfterLeave()
            delete this.message[option.key]
          }
        })
      }
      this.removeMessage(option.key, option.duration)
    }

    loading(content, option) {
      this.showMessage('loading', content, option)
    }

    success(content, option) {
      this.showMessage('success', content, option)
    }

    error(content, option) {
      this.showMessage('error', content, option)
    }

    info(content, option) {
      this.showMessage('info', content, option)
    }

    warning(content, option) {
      this.showMessage('warning', content, option)
    }
  }

  return new Message()
}

export function setupDialog(NDialog) {
  NDialog.confirm = function (option = {}) {
    const showIcon = !isNil(option.title)
    return NDialog[option.type || 'warning']({
      showIcon,
      positiveText: '确定',
      negativeText: '取消',
      onPositiveClick: option.confirm,
      onNegativeClick: option.cancel,
      onMaskClick: option.cancel,
      ...option
    })
  }

  return NDialog
}

interface NotificationOption {
  key?: string
  type?: string
  content?: string
  title?: string
  duration?: number
  placement?: string
  containerClass?: string
  onAfterLeave?: () => unknown
}
export function setupNotification() {
  class Notification {
    static instance: Notification
    constructor() {
      // 单例模式
      if (Notification.instance) return Notification.instance
      Notification.instance = this
    }

    create(option: NotificationOption = {}) {
      const { type } = option
      const notificationProviderProps = {}
      if (option.placement) {
        notificationProviderProps.placement = option.placement
      }
      if (option.containerClass) {
        notificationProviderProps.containerClass = option.containerClass
      }
      const { notification } = NaiveUI.createDiscreteApi(['notification'], {
        notificationProviderProps
      })
      console.log(notification, type, option)
      notification[type](option)
    }

    success(option: NotificationOption) {
      this.create({
        ...option,
        type: 'success'
      })
    }

    error(option: NotificationOption) {
      this.create({
        ...option,
        type: 'error'
      })
    }

    info(option: NotificationOption) {
      this.create({
        ...option,
        type: 'info'
      })
    }

    warning(option: NotificationOption) {
      this.create({
        ...option,
        type: 'warning'
      })
    }
  }
  return new Notification()
}

export function setupUiApi(app) {
  const appStore = useAppStore()
  const configProviderProps = computed(() => ({
    themeOverrides: appStore.naiveThemeOverrides
  }))
  const messageProviderProps = {
    duration: 1500
  }
  const { message, dialog } = NaiveUI.createDiscreteApi(['message', 'dialog'], {
    configProviderProps,
    messageProviderProps
  })

  if (app) {
    app.config.globalProperties.$naiveTools = {
      $message: setupMessage(message),
      $dialog: setupDialog(dialog),
      $notification: setupNotification()
    }
  }
  window.$message = setupMessage(message)
  window.$dialog = setupDialog(dialog)
  window.$notification = setupNotification()
}
